module.exports = __webpack_public_path__ + "img/logo.0bfcf93c.jpg";